import {Button, Col, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import API from "../api/api"
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import "./Game.css";
import ProfileIcon from "../components/ProfileIcon";

function Game() {
    const [game, setGame] = useState(false);
    const [developers, setDevelopers] = useState([]);
    const params = useParams();
    const gameName = params.gameName;
    const [slideIndex, setSlideIndex] = useState(1);
    const [owned, setOwned] = useState(false);
    const [gameDescription, setGameDescription] = useState("");

    const showdown = require('showdown');
    const converter = new showdown.Converter();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        API.get("games/get-by-name?game=" + gameName).then(response => {
            const markdownContent = response.data.full_description;
            setGameDescription(converter.makeHtml(markdownContent));
            setGame(response.data);
        }).catch(error => {
            console.log(error);
        })
    }, []);

    useEffect(() => {
        if (game) {
            showSlides(slideIndex);
            let foundDevelopers = [];
            API.get("users/team-members").then(response => {
                response.data.forEach((user) => {
                    if (game.developers.includes(user.username)) {
                        foundDevelopers.push(user);
                    }
                })
                setDevelopers(foundDevelopers);
            }).catch(error => {
                console.log(error);
            })
        }
    }, [game])

    useEffect(() => {
        if (game) {
            showSlides(slideIndex);
        }
    }, [slideIndex]);

    useEffect(() => {
        setSlideIndex(slideIndex);
    }, [developers])


    // Next/previous controls
    function plusSlides(n) {
        setSlideIndex(slideIndex + n);
    }

    // Thumbnail image controls
    function currentSlide(n) {
        setSlideIndex(n);
    }


    function showSlides(n) {
        let slides = document.getElementsByClassName("mySlides");
        let dots = document.getElementsByClassName("dot");
        let i;
        if (n > slides.length) {
            setSlideIndex(1);
            return;
        }
        if (n < 1) {
            setSlideIndex(slides.length);
            return;
        }
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
        }
        slides[slideIndex - 1].style.display = "block";

        if (game.images_url ? game.images_url.length : 0) {
            dots[slideIndex - 1].className += " active";
        }
    }

    return (
        <div className="bg-gradient-dark text-white">
            <Container data-bs-theme="dark" className="mt-5 min-vh-100">
                {!game &&
                    <div className="spinner-border" role="status">
                    </div>
                }
                {game && (
                    <>
                        <strong><p className="display-4 fw-bold text-center mb-5">{game.name}</p></strong>
                        <div className="gallery">
                            <div className="slideshow-container">
                                {game.video_link && (
                                    <div className="mySlides">
                                        <iframe className="game-video" src={game.video_link}
                                                title="YouTube video player"
                                                frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;
                            picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin"
                                                allowFullScreen></iframe>
                                    </div>
                                )}

                                {game.images_url.map((url, index) => (
                                    <div key={index} className="mySlides">
                                        <div
                                            className="numbertext">{index + game.video_link ? 2 : 1} / {game.images_url.length + game.video_link ? 1 : 0}</div>
                                        <img src={game.images_url[index]} className="game-image"/>
                                    </div>
                                ))}

                                {(game.images_url.length + (game.video_link ? 1 : 0)) > 1 && (
                                    <>
                                        <a className="prev text-decoration-none" onClick={(e) => {
                                            plusSlides(-1)
                                        }}>&#10094;</a>
                                        <a className="next text-decoration-none" onClick={(e) => {
                                            plusSlides(1)
                                        }}>&#10095;</a>
                                    </>
                                )}
                            </div>
                            <br/>
                            {game.images_url.length > 0 && (
                                <div className="d-flex justify-content-center">
                                    {game.video_link && (
                                        <span key={0} className="dot" onClick={(e) => {
                                            currentSlide(1)
                                        }}></span>
                                    )}
                                    {game.images_url.map((url, index) => (
                                        <span key={index + 1} className="dot" onClick={(e) => {
                                            currentSlide(index + (game.video_link ? 2 : 1))
                                        }}></span>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="d-flex justify-content-center">
                            {((!game.price || owned) && (!game.web_only)) && (
                                <Button className="m-5 bg-success border-0 btn-lg" onClick={(e) => {
                                    window.open(game.external_download_link, '_blank')
                                }}>
                                    Download
                                </Button>
                            )}
                            {((game.price && !owned) && !game.web_only) && (
                                <Button className="m-5 bg-success border-0 btn-lg">
                                    Buy
                                </Button>
                            )}
                            {game.web_only && (
                                <Button className="m-5 bg-success border-0 btn-lg" onClick={(e) => {
                                    window.open(game.external_download_link, '_blank')
                                }}>
                                    Play
                                </Button>
                            )}
                            {/*<Button className="m-5 bg-danger border-0 btn-lg">
                            Like
                        </Button>*/}
                        </div>

                        <br/>
                        <div className="m-3" dangerouslySetInnerHTML={{__html: gameDescription}}></div>

                        {developers.length > 0 && (
                            <>
                                <h2 className="text-center h2 m-5">Meet The Team:</h2>
                                <div>
                                    <Row className="justify-content-center">
                                        {developers.map((member, i) => (
                                            <Col key={i} md={6} lg={4} xl={3} className="text-center mb-4">
                                                <div className="developer-profile">
                                                    <ProfileIcon {...member} />
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </>
                        )}
                    </>
                )}
            </Container>

        </div>
    );
}

export default Game;